<template>
    <div class="teamSet" id="teamSet">
        <div class="mainContent">
            <div class="accountsSafe_head flex align-cen">
                <div class="accountsSafe_head_item flex align-cen">
                    <div class="accountsSafe_head_item_key">团队名称</div>
                    <div class="accountsSafe_head_item_value">{{bussName}}</div>
                </div>
                  <div class="accountsSafe_head_item flex align-cen">
                    <div class="accountsSafe_head_item_key">团队ID</div>
                    <div class="accountsSafe_head_item_value">{{businessInfo.id}}</div>
                </div>
                <div class="mft" @click="openBD">
                    <span class="icon-al-edit"></span>
                    修改
                </div>
            </div> 
            <div class="accountsSafe_content">
                <div class="accountsSafe_content_item flex align-cen">
                    <div class="accountsSafe_item_status"></div>
                    <div class="accountsSafe_item_icon">
                       <img src="../../../assets/images/teamYj.svg" alt="">
                    </div>
                    <div class="accountsSafe_item_title">移交团队</div>
                    <div class="accountsSafe_item_remark">每个团队只有1位所有者，移交后你将不再是超级管理员</div>
                    <div class="accountsSafe_item_operate mft">
                        <div class="accountsSafe_item_btn"  @click="swichBuss">移交</div>
                    </div>
                </div>
                 <div class="accountsSafe_content_item flex align-cen">
                    <div class="accountsSafe_item_status"></div>
                    <div class="accountsSafe_item_icon">
                        <img src="../../../assets/images/teamClose.svg" alt="">
                        <!-- <span class="icon-al-poweroff"></span> -->
                    </div>
                    <div class="accountsSafe_item_title">退出团队</div>
                    <div class="accountsSafe_item_remark">当非企业管理员时，能够退出团队</div>
                    <div class="accountsSafe_item_operate mft">
                        <div class="accountsSafe_item_btn" @click="logoutBuss">退出</div>
                    </div>
                </div>
            </div>
        </div>
    <!-- 选择成员列表 -->
     <el-dialog
  title="选择成员"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  
  >
   <div class="forminfo"> 
    <adminTemplate
    :authType='1'
    @sendStatus="emitFun" 
    ></adminTemplate>
    <div class="authbtn flex align-cen">
             <!-- <el-button plain @click="reback1(0)">取消</el-button>
              <el-button type="primary" class="mft" @click="onSubmit1">确认选择</el-button> -->
        </div>
   </div>
    </el-dialog>
    </div>
</template>
<script>
import { getBusiness, exitTeam,getCurrentUser} from "@/api/enterprise/index"; // 获取当前企业信息 、退出团队
import adminTemplate from "@/webenterpriseManage/Team/teamAdmin/index.vue"; //将应用管理页面作为组件使用
export default {
    name:'teamSet',
    inject: ["reload"],
     components:{
        adminTemplate
     },
    data () {
        return {
            centerDialogVisible:false,
            userinfo:{},
            businessInfo:{},
            bussName:'',
            currentInfo:{}
        }
    },
    created () {
         // 获取本地存储用户信息
            this.userinfo = this.$locaStorage.setAge().get('userinfo1')
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
            this.getbussInfo()
            this.getUserInfo()
    },
    methods: {
          // 获取当前用户信息
        getUserInfo(){
             getCurrentUser({
                id:this.businessInfo.id,
              },'enterprise')
            .then(res => {
            this.currentInfo = res.data.user_info
            })
        },
        // 自组件触发
        emitFun(val){
            if(val){
               this.$util.Notifi('移交成功','success','fa-check') 
               this.$bus.$emit("thisGetinfo",true);
                this.reload()
            }
        },
        // 移交团队
        swichBuss(){
           if(this.currentInfo.isAdmin != 1) return  this.$util.Notifi('您还不是超级管理员','error','fa-exclamation-circle');  
           this.centerDialogVisible = true  
        },
        // 退出团队
        logoutBuss(){     
            if(this.currentInfo.isAdmin == 1) return  this.$util.Notifi('请先移交团队后在执行此操作','error','fa-exclamation-circle'); 
        this.$confirm('选择退出团队后，您的账号将无法登录系统，仍然退出吗?','退出团队', {
          confirmButtonText: '仍然退出',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
            exitTeam({
              id:this.businessInfo.id,
              },'enterprise')
                .then(res => {
                 this.$util.Notifi('退出成功','success','fa-check')
                 this.$router.push('/webenterprise/enBusiness')
              })
              .catch(err => {
              })
        })
        },
        // 获取当前用户信息
        getbussInfo(){
             getBusiness({
                id:this.businessInfo.id
              },'enterprise')
            .then(res => {
             this.bussName = res.data.name
            })
        },
        // 打开企业详情页面
        openBD(){
            if(this.currentInfo.isAdmin == 0) return  this.$util.Notifi('暂无权限','error','fa-exclamation-circle'); 
            this.$router.push('/webenterpriseManage/busInessDetail')
        }
    },
}
</script>
<style lang="scss" scoped>
.teamSet{
    padding: 0.1px;
    .mainContent{
            margin: 30px auto 0px;
            width: 800px;
            background: rgb(255, 255, 255);
            box-shadow: rgba(197, 197, 197, 0.34) 0px 0px 7px 0px;
            border-radius: 2px;
            .accountsSafe_head{
                    height: 80px;
                    line-height: 80px;
                    background: rgb(246, 249, 255);
                    border-radius: 2px;
                    padding: 0px 20px;
                    overflow: hidden;
            .accountsSafe_head_item{
                margin-right: 40px;
                font-size: 0px;
                font-family: "Microsoft YaHei";
                font-weight: 400;
                .accountsSafe_head_item_key{
                    color: rgb(78, 78, 78);
                    font-size: 14px;
                }
                .accountsSafe_head_item_value{
                    color: #247af3;
                    font-size: 14px;
                    margin-left: 10px;
                }
            }
            .mft{
                cursor: pointer;
                font-size: 12px;
            }
            }
            .accountsSafe_content{
                background-color: rgb(255, 255, 255);
                padding: 0px 0px;
                .accountsSafe_content_item{
                    position: relative;
                    height: 114px;
                    border-bottom: 1px solid rgb(234, 234, 234);
                    padding: 0px 20px;
                    box-sizing: border-box;
                    .accountsSafe_item_status{
                        opacity: 0;
                        width: 26px;
                        height: 26px;
                    }
                   .accountsSafe_item_icon{
                        margin-left: 30px;
                        color: rgb(144, 144, 158);
                        span{
                         font-size: 30px;
                        }
                   }
                   .accountsSafe_item_title{
                        margin-left: 15px;
                        font-size: 16px;
                        color: rgb(78, 78, 78);
                        line-height: 110px;
                   }
                   .accountsSafe_item_remark{
                    margin-left: 20px;
                    font-size: 14px;
                    color: rgb(144, 144, 158);
                    line-height: 110px;
                   } 
                   .accountsSafe_item_operate{
                    width: 152px;
                    height: 28px;
                    .accountsSafe_item_btn{
                        width: 152px;
                        height: 28px;
                        line-height: 26px;
                        border: 1px solid rgba(1, 87, 255, 0.2);
                        border-radius: 14px;
                        box-sizing: border-box;
                        color: rgb(1, 87, 255);
                        cursor: pointer;
                        transition: background-color 0.3s linear 0s, border-color 0.3s linear 0s;
                        text-align: center;
                    }
                   }
                }
            }
    }
}
::v-deep{
 .el-dialog {
    margin-top: 5vh !important;
 }   
}
</style>